import { clearActivePopup } from 'actions';
import { clearActiveGroupPopup } from 'PopupGroup/PopupGroupActions';
import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import RecipientManagerConstants from './RecipientManagerConstants';

export const formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);

export const showAddRecipientsTab = () => (
  (dispatch) => {
    dispatch({
      type: RecipientManagerConstants.RECIPIENT_MANAGER_ADD_RECIPIENTS_TAB_SHOW,
    });
  }
);

export const showPublicLinkTab = () => (
  (dispatch) => {
    dispatch({
      type: RecipientManagerConstants.RECIPIENT_MANAGER_PUBLIC_LINK_TAB_SHOW,
    });
  }
);

export const shareCustomTemplate = (
  userId,
  userToken,
  documentType,
  emails,
  message,
  successCallback,
  redirectCallback,
) => (
  async (dispatch) => {
    dispatch({
      type: RecipientManagerConstants.RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_REQUEST,
      documentType,
    });

    try {
      const response = await formSwiftAPIClient.request('POST', '/document-share', {
        to: emails,
        message,
        document_type: documentType,
        builder_type: 'custom',
        user_id: userId,
        user_token: userToken,
      });

      const documentShares = response.data.document_shares;
      const publishedAt = response.data.published_at;
      const customTemplateSessions = documentShares.map(documentShare => ({
        owner_finished_session_hash: documentShare.owner_finished_session_hash,
        owner_finished_session_id: documentShare.owner_finished_session_id,
        share_email: documentShare.share_email,
        share_key: documentShare.share_key,
        updated_at: documentShare.updated_at,
      }));

      if (redirectCallback) {
        redirectCallback();
      } else {
        dispatch({
          type: RecipientManagerConstants.RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_SUCCESS,
          customTemplateSessions,
          publishedAt,
        });

        // Remove active popup
        dispatch(clearActivePopup());
        dispatch(clearActiveGroupPopup());

        if (successCallback) {
          successCallback();
        }
      }
    } catch (e) {
      dispatch({
        type: RecipientManagerConstants.RECIPIENT_MANAGER_CUSTOM_TEMPLATE_SHARE_FAILURE,
        error: e.message,
      });
    }
  }
);

export const publicLinkUpdateState = (documentType, makePublic) => (
  async (dispatch) => {
    try {
      let payload;
      const date = new Date();
      const curDate = date.toISOString();
      if (makePublic) {
        payload = {
          public: 1,
          published_at: curDate,
          creator_user_id: parseInt(window.COOKIE.get('userid'), 10),
          creator_user_token: window.COOKIE.get('userToken'),
        };
      } else {
        payload = {
          public: 0,
          creator_user_id: parseInt(window.COOKIE.get('userid'), 10),
          creator_user_token: window.COOKIE.get('userToken'),
        };
      }
      const response = await formSwiftAPIClient.request('POST', `/custom-template/${documentType}`, payload,
      );

      // Remove active popup
      dispatch(clearActivePopup());
      dispatch(clearActiveGroupPopup());

      const responseData = response.data;
      dispatch({
        type: RecipientManagerConstants.RECIPIENT_MANAGER_PUBLIC_LINK_UPDATE,
        data: responseData,
      });

      return response.data.custom_template.public;
    } catch (e) {
      dispatch({
        type: RecipientManagerConstants.RECIPIENT_MANAGER_PUBLIC_LINK_ERROR,
        error: e.message,
      });
      return e;
    }
  }
);



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/RecipientManagerActions.jsx